import React from "react";
import { Input } from "antd";

interface IProps {
  texto: any;
  setTexto: any;
  alltexto: any;
  name: string;
  onInput?: any;
  maxLength?: number;
}

export const InputTexto: React.FC<IProps> = (props: IProps) => {
  const toInputUppercase = (e: any) => {
    if (props.onInput != null) {
      e.target.value = ("" + e.target.value).toUpperCase();
    }
  };

  return (
    <Input
      maxLength={props.maxLength}
      onInput={toInputUppercase}
      value={props.texto}
      onChange={(e) =>
        props.setTexto({
          ...props.alltexto,
          [props.name]: e.target.value,
        })
      }
    />
  );
};
